"use client";

import { useEffect } from "react";
import { trackMetric } from "@/app/actions/public";
import type { MetricName } from "@/lib/source";

export function MetricBeacon({
  name,
  source,
  path,
}: {
  name: MetricName;
  source: string;
  path: string;
}) {
  useEffect(() => {
    void trackMetric(name, source, path);
  }, [name, source, path]);
  return null;
}
